import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { investmentFragmentId } from 'src/app/pages/summary/summary.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { LogoutService } from 'src/app/services/logout.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { UserNotificationService } from 'src/app/services/user-notification/user-notification.service';
import { Location } from '@angular/common';
import { CustomRoutingService } from 'src/app/services/custom-routing.service';
import { NativeSafeZoneService } from 'src/app/services/native-safe-zone.service';
import { SignalsService } from 'src/app/services/signals.service';
import { Subscription } from 'rxjs';
import { ConsultantStatus } from 'src/app/services/rest-api/rest-api';
import { NativeCheckService } from 'src/app/services/native-check.service';

// check global styles
export const MOBILE_MENU_BODY_CLASS = 'mobile-menu-open';

@Component({
  selector: 'libero-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  public desktopSmallMenuToggled = false;
  public desktopMenuElementId = 'desktop-small-user-menu';

  private menuTogglingWatcher: (() => void) | null = null;

  public mobileMenuVisible = false;

  public investmentFragmentId = investmentFragmentId;
  public investmentsLinkActive = false;
  private investmentsLinkActiveSub?: Subscription;

  public get displayBackArrow(): boolean {
    return this.nativeCheckService.isNativePlatform() && !this.router.url.startsWith('/summary');
  }

  public get offsetBackArrow(): boolean {
    return this.router.url.includes('isDraft=1');
  }

  public get isSummary(): boolean {
    return this.router.url.includes('/summary');
  }

  public get isMoney(): boolean {
    return this.router.url.includes('/money');
  }

  public get isBlog(): boolean {
    return this.router.url.includes('/blog');
  }

  public constructor(
    private router: Router,
    private renderer: Renderer2,
    public authenticationService: AuthenticationService,
    public logoutService: LogoutService,
    public modalService: ModalService,
    public userNotificationService: UserNotificationService,
    public location: Location,
    private customRoutingService: CustomRoutingService,
    public nativeSafeZoneService: NativeSafeZoneService,
    private signalsService: SignalsService,
    private nativeCheckService: NativeCheckService,
  ) { }

  public openModal(): void {
    this.modalService.openConsultModal();
  }

  public openMobileMenu(): void {
    this.mobileMenuVisible = true;
    this.renderer.addClass(document.body, MOBILE_MENU_BODY_CLASS);
  }

  public closeMobileMenu(): void {
    this.renderer.removeClass(document.body, MOBILE_MENU_BODY_CLASS);
    this.mobileMenuVisible = false;
  }

  public logOut(): void {
    this.closeMobileMenu();
    this.logoutService.logOut();
  }

  public closeMenuAndNavigate(route: string, scrollToSummaryInvestments?: boolean): void {
    this.closeMobileMenu();
    if(route === 'consultation') {
      this.modalService.openConsultModal();
    } else {
      this.router.navigate([route])
      if (scrollToSummaryInvestments) {
        this.onInvestmentsLinkClicked();
      }
    }
  }

  public toggleDesktopSmallMenu(event: Event): void {
    const eventTarget = event.target as HTMLElement | null;
    if(eventTarget?.id === this.desktopMenuElementId || eventTarget?.parentElement?.id === this.desktopMenuElementId) {
      return;
    }

    this.desktopSmallMenuToggled = !this.desktopSmallMenuToggled;

    if(this.desktopSmallMenuToggled) {
      // close menu on body click
      event.stopPropagation();
      event.preventDefault();
      this.menuTogglingWatcher = this.renderer.listen('window', 'click', (e: Event) => {
        const listenerEventTarget = e.target as HTMLElement | null;
        if(
          !(listenerEventTarget?.id === this.desktopMenuElementId) &&
          !(listenerEventTarget?.parentElement?.id === this.desktopMenuElementId)
        ) {
          this.desktopSmallMenuToggled = false;
          this.removeMenuWatcher();
        }
      }).bind(this)
    } else {
      this.removeMenuWatcher();
    }
  }

  private removeMenuWatcher(): void {
    if(this.menuTogglingWatcher) {
      this.menuTogglingWatcher();
      this.menuTogglingWatcher = null;
    }
  }

  public redirectBack(): void {
    this.customRoutingService.routeBack();
  }

  public ngOnInit(): void {
    this.investmentsLinkActiveSub = this.signalsService.investmentsSectionInView$
      .subscribe(inView => this.investmentsLinkActive = inView);
  }

  public ngOnDestroy(): void {
    this.investmentsLinkActiveSub?.unsubscribe();
  }

  public onInvestmentsLinkClicked(): void {
    this.investmentsLinkActive = true;
    this.signalsService.investmentsTopNavLinkClicked();
  }

  public get consultationLinkActive(): boolean {
    return !!(
      // consultant not fetched message in modal
      (this.modalService.consultant?.value.status === ConsultantStatus.NOT_FOUND && !this.modalService.preloader) ||
      // consultant fetched message in modal
      (this.modalService.consultant && !this.modalService.preloader)
    );
  }

}
